import React, { Component } from "react";
import dayjs from "dayjs";
import { s360ConfigService } from "../../Services/S360Config";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";

class Redirect extends Component {


    constructor(props) {
        super(props);
      }
    render() {
        let text      = (this.props.entry && this.props.entry.text) || "";
        if (this.props.entry && this.props.entry.keyword) {
            text = text;
        }
        
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <button 
                    disabled={this.props.disabled} 
                    className={`${this.messageBoxClassName()} btn-check btn-redirect ${this.props.config.designDetails?.hideButtonMargin ? "margin-0" : ""}`}
                    style={this.messageBoxStyle()}  
                    onMouseEnter={this.onMouseEnterButton} 
                    onMouseLeave={this.onMouseLeaveButton}  
                    {...(this.isActiveConversation() && {onClick:this.onMessageSend})}
                >
                    {text}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: "6px", verticalAlign: "middle", flexShrink: 0 }}>
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                </button>
                {this.props.isLastEntry && this.props.sentTimestamp&& <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
            </div>
        )
    }

    onMouseEnterButton = (e) => {
        if (!e.target) { return }
        if (e.target.disabled === true) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonHighlightTextColor)       ? "#f8f5f5" : designDetails.buttonHighlightTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "#2935dd" : designDetails.buttonHighlightBackgroundColor;
        e.target.style.borderColor = isNullOrUndefined(
              designDetails.buttonHighlightBorderColor
            )
              ? isNullOrUndefined(designDetails.buttonBorderColor)
                ? "#0092ed"
                : designDetails.buttonBorderColor
              : designDetails.buttonHighlightBorderColor;
    }

    onMouseLeaveButton = (e) => {
        // if (e.target.disabled === true) { return }
        if (!e.target) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "#0092ed" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "#fff" : designDetails.buttonBackgroundColor;
        e.target.style.borderColor = isNullOrUndefined(designDetails.buttonBorderColor)
            ? "#0092ed"
            : designDetails.buttonBorderColor;
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
        // switch (this.props.message.type) {
        //     // case MessageType.sent: return "s360-message-time-sent";
        //     // case MessageType.received: return "s360-message-time-received";
        //     // case MessageType.info: return "s360-message-time-info";
        //     default: return "";
        // }
    }

    messageBoxClassName = () => {
        //return "s360-message-box-received";
        return `btn btn-chat${this.props.config.designDetails?.hideButtonBoxShadow ? " box-shadow-none" : ""}`;
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-box-sent";
        //     case MessageType.received: return "s360-message-box-received";
        //     case MessageType.info: return "s360-message-box-info";
        //     default: return "";
        // }
    }

    messageContainerClassName = () => {
        return this.props.config.autoFullScreen
        ? "s360-message-cotainer-received-fs"
        : "s360-message-cotainer-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-cotainer-sent";
        //     case MessageType.received: return "s360-message-cotainer-received";
        //     case MessageType.info: return "s360-message-cotainer-info";
        //     default: return "";
        // }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        // return { 
        //     background: config.designDetails.senderMessageColor, 
        //     fontFamily: config.designDetails.SenderMessageFont,
        //      fontSize: config.designDetails.SenderMessageFontSize, 
        //      color: config.designDetails.senderMessageFontColor
        //      }
        const designDetials = config.designDetails;
        let styleData = {
            // background: config.designDetails.senderMessageColor, 
            fontFamily: config.designDetails.SenderMessageFont,
            fontSize: config.designDetails.SenderMessageFontSize,
            marginLeft: '15px',
            borderWidth:"1px", 
            borderStyle: "solid",
            width: isNullOrUndefined(designDetials.buttonWidth)
                    ? "fit-content"
                    : designDetials.buttonWidth,
            borderColor: isNullOrUndefined(designDetials.buttonBorderColor) ? "#0092ed" : designDetials.buttonBorderColor,
            borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius) ? 20 : designDetials.buttonBorderRadius,
            color: isNullOrUndefined(designDetials.buttonTextColor) ? "#0092ed" : designDetials.buttonTextColor,
            backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor) ? "#fff" : designDetials.buttonBackgroundColor,
            justifyContent:  isNullOrUndefined(designDetials.redirectBtnJustifyContent) ? "center" : designDetials.redirectBtnJustifyContent,
        }
        return styleData;
        // switch (this.props.message.type) {
        //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
        //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

    messageContainerStyle = () => {
        const config = this.props.config
        const styles = {};
        if (config.designDetails?.btnContainerPadding) {
          styles.padding = config.designDetails.btnContainerPadding;
        }

        return styles
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { 
            fontFamily: config.designDetails.messageFont, 
            fontSize: config.designDetails.messageTimeFontSize, 
            color: config.designDetails.messageTimeFontColor,
            textAlign: config.designDetails.incomingMessageTextAlign || 'left',
            marginRight: '0',
        }
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        // switch (this.props.message.type) {
        //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }


    onMessageSend = (e) => {
        this.onMouseLeaveButton(e);

        var n = document.getElementsByClassName("btn btn-chat");

        for(var i=0;i<n.length;i++){
            n[i].disabled = true;
            this.onMouseLeaveButton(n[i]);
         }
     
       // this.props.actions.sendMessage(this.props.entry.keyword);
       this.props.actions.sendMessageWithCode(this.props.entry.keyword, this.props.entry.text);
        const link = document.createElement('a');
        link.href = this.props.entry.url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
        
    }


    isActiveConversation = () => {
        let isClosed = (this.props.activeConversation && this.props.activeConversation.active != null && this.props.activeConversation.active !== undefined && this.props.activeConversation.active === false) || this.props.isConversationClosed;
        return !isClosed;
    }

}

export default Redirect;